// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__UjSYm","checkbox__icon":"Checkbox_checkbox__icon__CqIty"};